import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  connect() {
    this.onInput = () => this.#sync()
    this.inputTarget.addEventListener("input", this.onInput)
    this.#sync()
    this.onMorph = () => this.#sync()
    document.addEventListener("turbo:morph", this.onMorph)
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.onInput)
    if (this.onMorph) document.removeEventListener("turbo:morph", this.onMorph)
  }

  clear() {
    this.inputTarget.value = ""
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.focus()
    this.#sync()
  }

  #sync() {
    this.buttonTarget.classList.toggle("hidden", this.inputTarget.value.length === 0)
  }
}
